import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { TextSettingsProvider } from './contexts/TextSettingsContext';
import { ImageProvider } from './contexts/ImageContext';
import { VectorProvider } from './contexts/VectorContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <TextSettingsProvider>
        <ImageProvider>
          <VectorProvider>
            <App />
          </VectorProvider>
        </ImageProvider>
      </TextSettingsProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
